export function getAccessToken() {
  return localStorage.getItem("auth_token");
}

export function getRefreshToken() {
  return localStorage.getItem("refresh_token");
}

export function setTokens(accessToken, refreshToken) {
  localStorage.setItem("auth_token", accessToken);
  localStorage.setItem("refresh_token", refreshToken);
}

export function clearTokens() {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("refresh_token");
}
